export default store => {
  store.watch((state, getters) => getters['siteConfig/config'], (newConfig, oldConfig) => {        
    if (newConfig && newConfig.site_title) {
      document.title = newConfig.site_title;
    }
  });
}